import styled from 'styled-components';
import { Body1Styles, Overline } from '../typography';
import { Button } from '../button';
import { getSizeBy, getColor, getColorShade, getThemeProp } from '../../../src/styled/utils';
import { Chip } from '../chip';
const sizeLiteral = { small: 5.5, medium: 7.5, large: 9.5 };
export const Wrap = styled.div `
  background: ${({ disabled }) => disabled ? getColorShade('onSurface', 'outline') : getColor('surface')};
  border: 1px solid ${getColorShade('onSurface', 'outline')};
  border-radius: ${getThemeProp('borderRadius')}px;
`;
export const ChipWrap = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 1px;
`;
export const StyledButton = styled(Button) `
  padding: 0 ${getSizeBy(2)} 0 0;
`;
export const Input = styled.input `
  display: inline-block;
  flex-basis: ${getSizeBy(26)};
  flex-grow: 1;
  height: ${({ sizeComponent }) => getSizeBy(sizeLiteral[sizeComponent])};
  color: ${({ disabled }) => disabled ? getColorShade('onSurface', 'lowEmphasis') : getColor('onSurface')};
  background-color: ${({ disabled }) => (disabled ? 'transparent' : getColor('surface'))};
  border: 1px solid ${({ isValid }) => (isValid ? 'transparent' : getColor('danger'))};
  border-radius: 3px;
  ${Body1Styles}

  &::placeholder {
    color: ${getColorShade('onSurface', 'lowEmphasis')};
  }

  &:focus {
    outline: none;
  }
`;
export const StyledChip = styled(Chip).attrs({ 'data-testid': 'chip' }) ``;
export const SuggestWrap = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${getSizeBy(2)};
  max-height: ${getSizeBy(28)};
  padding: ${getSizeBy(2)};
  overflow-y: auto;
`;
export const Suggest = styled(Overline) `
  padding: ${getSizeBy(0.5)} ${getSizeBy(1)};
  white-space: nowrap;
  background-color: ${getColorShade('onSurface', 'selected')};
  border-radius: ${getSizeBy(1)};
  cursor: pointer;
`;
